// extracted by mini-css-extract-plugin
module.exports = {"code_icon":"Style_code_icon__1wn0l","applied_column":"Style_applied_column__3KKlI"};